/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Import_CompleteInputs */

const en_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Complete.`)
};

const fr_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation terminée.`)
};

const de_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import abgeschlossen.`)
};

const it_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione completata.`)
};

const ru_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт завершен.`)
};

const es_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación completada.`)
};

const zh_cn2_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入完成。`)
};

const ja_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートが完了しました。`)
};

const hi_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात पूर्ण हुआ।`)
};

const pt_pt2_ateliere_connect_status_import_complete = /** @type {(inputs: Ateliere_Connect_Status_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação concluída.`)
};

/**
* | output |
* | --- |
* | "Import Complete." |
*
* @param {Ateliere_Connect_Status_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_import_complete = /** @type {((inputs?: Ateliere_Connect_Status_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_import_complete(inputs)
	if (locale === "de") return de_ateliere_connect_status_import_complete(inputs)
	if (locale === "it") return it_ateliere_connect_status_import_complete(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_import_complete(inputs)
	if (locale === "es") return es_ateliere_connect_status_import_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_import_complete(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_import_complete(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_import_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_import_complete(inputs)
	return en_ateliere_connect_status_import_complete(inputs)
});